<template>
    <v-card v-show="showSearch" class="elevation-1 mx-auto">
        <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="3">
                    <v-date-field v-model="query.createdAt[0]" label="작성일자(시작)" persistent-placeholder dense hide-details />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-date-field v-model="query.createdAt[1]" label="작성일자(종료)" persistent-placeholder dense hide-details />
                </v-col>
                <v-col cols="6" md="3">
                    <v-select v-model="query.searchKey" :items="searchKeys" label="검색조건" persistent-placeholder dense hide-details @change="() => (query.searchValue = '')" />
                </v-col>
                <v-col cols="6" md="3">
                    <v-text-field v-model="query.searchValue" label="검색어" persistent-placeholder :disabled="!query.searchKey" dense hide-details @keydown.enter="setQuery" />
                </v-col>
            </v-row>
            <v-row class="mt-5">
                <v-col cols="6">
                    <v-autocomplete v-model="query['_user']" :items="userItems" label="회원" persistent-placeholder dense hide-details @change="setQuery" />
                </v-col>
                <v-col cols="6">
                    <v-select v-model="query['type']" :items="typeItems" label="종류" persistent-placeholder dense hide-details @change="setQuery" />
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" rounded text @click="clearQuery"><v-icon small class="mt-1 mr-2">mdi-replay</v-icon>초기화</v-btn>
            <v-btn color="primary" rounded text @click="setQuery"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import api from "@/api";
import { LOG_TYPES } from "@/assets/variables";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

let initQuery = (query = {}) => ({
    ...query,
    ["searchKey"]: query?.["searchKey"] || null,
    ["searchValue"]: query?.["searchValue"] || null,

    ["_user"]: query?.["_user"] || null,
    ["type"]: query?.["type"] || null,

    ["createdAt"]: [(query?.["createdAt"] || [])[0], (query?.["createdAt"] || [])[1]],
});
export default {
    components: {
        VDateField,
    },
    data: () => ({
        showSearch: true,
        query: initQuery(),
        searchKeys: [
            { text: ":: 전체 ::", value: null },
            { text: "내용", value: "content" },
            { text: "ip", value: "ip" },
        ],
        searchKey: null,
        searchValue: null,

        typeItems: [{ text: ":: 전체 ::", value: null }, ...Object.values(LOG_TYPES)],
        userItems: [],
    }),
    mounted() {
        this.search();
        this.sync();
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        async search() {
            let { users } = await api.console.users.gets();
            this.userItems = [{ text: ":: 전체 ::", value: null }, ...users.map(({ name, _id }) => ({ text: name, value: _id }))];
        },
        setQuery() {
            const { ...query } = this.query || {};

            if (!query?.["_user"]) delete query["_user"];
            if (!query?.["type"]) delete query["type"];

            if (!query?.["createdAt"]) delete query["createdAt"];
            if (!query?.["createdAt"]?.[0] && !query?.["createdAt"]?.[1]) delete query["createdAt"];

            if (!query?.["searchKey"]) delete query["searchKey"];
            if (!query?.["searchValue"]) delete query["searchValue"];

            delete query.page;

            this.$router.push({ query });
        },
        clearQuery() {
            this.query = initQuery();
            this.setQuery();
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
};
</script>

<style>
</style>